/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ErroreClientExportDTO } from '../model/models';
import { ErroreClientOccorrenzaListFilter } from '../model/models';
import { ErroreClientProblemaDTO } from '../model/models';
import { ErroreClientProblemaListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelErroreClientOccorrenzaDTO } from '../model/models';
import { PagedModelErroreClientProblemaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ExportErroriClientRequestParams {
    filter: ErroreClientProblemaListFilter;
}

export interface GetErroreClientProblemaRequestParams {
    id: string;
}

export interface ListErroreClientOccorrenzeRequestParams {
    id: string;
    filter: ErroreClientOccorrenzaListFilter;
    pageable: Pageable;
}

export interface ListErroriClientRequestParams {
    filter: ErroreClientProblemaListFilter;
    pageable: Pageable;
}


export interface ErroriClientGestioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Export dei problemi di errore client con le ultime occorrenze (SUPERADMIN).
     * Stessi filtri della lista. Restituisce fino a 500 problemi, i piu\&#39; frequenti prima, ciascuno con le 5 occorrenze piu\&#39; recenti (stack completo, pagina, versione, piattaforma, user agent). Non contiene l\&#39;identita\&#39; di chi ha avuto l\&#39;errore: niente actor_user_id ne\&#39; actor_snapshot. \&#39;troncato\&#39; vale true se i problemi filtrati sono piu\&#39; di quelli esportati.
     * @endpoint get /api/v1/gestione/errori-client/export
* @param requestParameters
     */
    exportErroriClient(requestParameters: ExportErroriClientRequestParams, extraHttpRequestParams?: any): Observable<ErroreClientExportDTO>;

    /**
     * Dettaglio di un problema di errore client (SUPERADMIN).
     * 
     * @endpoint get /api/v1/gestione/errori-client/{id}
* @param requestParameters
     */
    getErroreClientProblema(requestParameters: GetErroreClientProblemaRequestParams, extraHttpRequestParams?: any): Observable<ErroreClientProblemaDTO>;

    /**
     * Lista paginata delle occorrenze (chi e quando) di un problema (SUPERADMIN).
     * Filtro opzionale attore (nome/email di chi ha avuto l\&#39;errore). Ordinamento FISSO ultimaVolta desc: un parametro \&#39;sort\&#39; eventualmente inviato dal client viene ignorato (page/size restano gli unici parametri di paginazione effettivi).
     * @endpoint get /api/v1/gestione/errori-client/{id}/occorrenze
* @param requestParameters
     */
    listErroreClientOccorrenze(requestParameters: ListErroreClientOccorrenzeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelErroreClientOccorrenzaDTO>;

    /**
     * Lista paginata dei problemi di errore client (SUPERADMIN).
     * Filtri opzionali: q (tipo/messaggio/form/campo), app, origine, attore (nome/email di chi ha avuto l\&#39;errore, su almeno un\&#39;occorrenza conservata), actor_user_id, da/a (intervallo sulle occorrenze conservate). Ordinamento predefinito ultimaOccorrenza desc; ammessi anche primaOccorrenza e contatore.
     * @endpoint get /api/v1/gestione/errori-client
* @param requestParameters
     */
    listErroriClient(requestParameters: ListErroriClientRequestParams, extraHttpRequestParams?: any): Observable<PagedModelErroreClientProblemaDTO>;

}
